import React from 'react';
import T from 'prop-types';
import ReactDatepicker from 'react-datepicker';
// components
import Input from '../../components/Input/Input';
// utils
import momentTypes from 'react-moment-proptypes';
// styles
import 'react-datepicker/dist/react-datepicker.css';
import './Datepicker.css';

const Datepicker = ({ name, invalid, secondary, color, ...restProps }) => (
  <ReactDatepicker
    dateFormat="DD/MM/YYYY"
    showYearDropdown
    customInput={
      <Input name={name} color={color} invalid={invalid} icon="calendar" />
    }
    popperClassName="rdp-popper"
    calendarClassName={`rdp-calendar ${secondary && 'secondary'}`}
    {...restProps}
  />
);

Datepicker.propTypes = {
  selected: momentTypes.momentObj,
  onChange: T.func.isRequired,
  secondary: T.bool
};

export default React.memo(Datepicker);



// WEBPACK FOOTER //
// ./src/components/Datepicker/Datepicker.jsx